import { render, staticRenderFns } from "./memberBuddyCard.vue?vue&type=template&id=d4718fe0&"
import script from "./memberBuddyCard.vue?vue&type=script&lang=js&"
export * from "./memberBuddyCard.vue?vue&type=script&lang=js&"
import style0 from "./memberBuddyCard.vue?vue&type=style&index=0&id=d4718fe0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports